export default {
  fr: {
    comments: (count: number) => (count > 1 ? 'commentaires' : 'commentaire'),
    thanksToYou: 'Grâce à vous 👏',
    thanksToGenerosity: 'Grâce à votre générosité 👏',
    noContribution: 'Le projet attend son premier don !',
    youFund: 'Vous financez',
    youContribute: 'Vous contribuez à',
    points: 'points',
  },
  en: {
    comments: (count: number) => (count > 1 ? 'comments' : 'comment'),
    thanksToYou: 'Thanks to you 👏',
    thanksToGenerosity: 'Thanks to your generosity 👏',
    noContribution: 'The project is waiting for its first donation!',
    youFund: 'You fund',
    youContribute: 'You contribute to',
    points: 'points',
  },
  'pt-br': {
    comments: (count: number) => (count > 1 ? 'comentários' : 'comentário'),
    thanksToYou: 'Graças a você 👏',
    thanksToGenerosity: 'Graças à sua generosidade 👏',
    noContribution: 'O projeto está esperando sua primeira doação!',
    youFund: 'Você financia',
    youContribute: 'Você contribui para',
    points: 'pontos',
  },
  es: {
    comments: (count: number) => (count > 1 ? 'comentarios' : 'comentario'),
    thanksToYou: 'Gracias a ti 👏',
    thanksToGenerosity: 'Gracias a tu generosidad 👏',
    noContribution: '¡El proyecto está esperando su primera donación!',
    youFund: 'Usted financia',
    youContribute: 'Usted contribuye a',
    points: 'puntos',
  },
  de: {
    comments: (count: number) => (count > 1 ? 'comments' : 'comment'),
    thanksToYou: 'Dank an Sie 👏',
    thanksToGenerosity: 'Dank Ihrer Großzügigkeit 👏',
    noContribution: 'Das Projekt wartet auf seine erste Spende!',
    youFund: 'Sie finanzieren',
    youContribute: 'Sie tragen dazu bei',
    points: 'Punkten',
  },
} as const
